<template>
    <li class="tree__entry">
        <div class="tree__label">
            <div  @click="loadQualification(node.qualification_to.id, node)" style="cursor: pointer;">
            <p class="tree__code">{{ node.qualification_to.code }}</p>
            <p class="tree__name">{{ node.qualification_to.name }}</p>
            </div>

            <div class="tree__icon">
              <button v-if="node.id" :class="{'settings-btn': true, 'has-programs': node.education_programs}" @click="loadTrainingPrograms(node)">
                <icon-base viewBox="0 0 12 14" :class="{'settings-btn__icon': true}"  class="" >
                  <icon-book/>
                </icon-base>
              </button>
            </div>

            <div class="tree__icon--bottom" v-if="this.GET_SHOW_DIAGRAM_ADD() && !read">
                <button type="button" class="settings-btn" @click.stop="openAdd(node.qualification_to.id)">
                  <icon-base width="10" height="10" viewBox="0 0 8 14"><icon-arrow-right /></icon-base>
                </button>
            </div>
        </div>

        <div class="tree__branch" v-if="node.qualification_to && node.qualification_to.trainings && node.qualification_to.trainings.length">
            <ul class="tree__branch_related" :class="{'tree__branch_has-inherited': node.qualification_to.trainings.filter(el => el.relation_type === 'inherited').length}" ref="related" v-if="node.qualification_to.trainings.filter(el => el.relation_type === 'related' && checkForCurrentParent(el)).length">
                <node
                    v-for="training in node.qualification_to.trainings.filter(el => el.relation_type === 'related' && checkForCurrentParent(el))"
                    :class="{ 'is-single': node.qualification_to.trainings.filter(el => checkForCurrentParent(el)).length === 1 }"
                    :node="training"
                    :read="read"
                     @openProgramsDialog="loadTrainingPrograms"
                     @openQualificationsPanel="loadQualification"
                     @openAddPanel="openAdd"
                />
            </ul>

            <ul class="tree__branch_inherited" :class="{'tree__branch_has-related': node.qualification_to.trainings.filter(el => el.relation_type === 'related').length}" ref="inherited" v-if="node.qualification_to.trainings.filter(el => el.relation_type === 'inherited' && checkForCurrentParent(el)).length">
                <node
                    v-for="training in node.qualification_to.trainings.filter(el => el.relation_type === 'inherited' && checkForCurrentParent(el))"
                    :class="{ 'is-single': node.qualification_to.trainings.filter(el => checkForCurrentParent(el)).length === 1 }"
                    :node="training"
                    :read="read"
                     @openProgramsDialog="loadTrainingPrograms"
                     @openQualificationsPanel="loadQualification"
                     @openAddPanel="openAdd"
                />
            </ul>
        </div>
    </li>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: 'node',
    props: {
        node: {
            type: Object
        },
        read: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.addheight()
    },
    //  Добавляем при каждом обновлении, потому что панель траекторий открывают заново без mounted()
    updated() {
      this.addheight()
    },
  methods: {
        ...mapGetters('common', ['GET_CURRENT_PARENT', 'GET_SHOW_DIAGRAM_ADD']),

        loadTrainingPrograms(training) {
            console.log(training);
            this.$emit('openProgramsDialog', training)
        },
        loadQualification(qualification) {
          console.log(qualification);
          this.$emit('openQualificationsPanel', qualification)
        },
        addheight() {
            const relatedEl = this.$refs.related
            const inheritedEl = this.$refs.inherited

            if (relatedEl && inheritedEl) {
                if (relatedEl.scrollHeight >= inheritedEl.scrollHeight) {
                    inheritedEl.style.height = relatedEl.scrollHeight + 'px'
                } else {
                    relatedEl.style.height = inheritedEl.scrollHeight + 'px'
                }
            }
        },
        openAdd(id) {
          this.$emit('openAddPanel', id);
        },
        checkForCurrentParent(el) {
          return (el.parent == null || this.GET_CURRENT_PARENT() == el.parent.id) && el.id != this.GET_CURRENT_PARENT();
        }
    }
}
</script>

<style>
  .has-programs {
    color: #f3a83e;
    border: 1px solid #f3a83e !important;
  }

  .has-programs .settings-btn__icon {
    color: #f3a83e !important;
  }

  .has-programs:hover {
    color: #dc922a !important;
  }
</style>
